<template>
  <div :class="['sharePane', enableLinks, mode]">
    <amp-social-share type="facebook" 
                      class="facebook"
                      :data-param-url="facebookUrl"
                      :data-param-app_id="facebookAppID">
      <svg-facebook-icon class="icon--facebook"></svg-facebook-icon>
    </amp-social-share>

    <amp-social-share type="twitter" 
                      class="facebook" 
                      :data-param-url="twitterUrl" 
                      :data-param-text="shareTitle">
      <svg-twitter-icon class="icon--twitter"></svg-twitter-icon>
    </amp-social-share>
    
    <amp-social-share type="whatsapp" class="whatsapp" :data-param-text="shareTitle">
      <svg-whatsapp-icon class="icon--whatsapp"></svg-whatsapp-icon>
    </amp-social-share>

    <amp-social-share type="facebookmessenger"
        :data-share-endpoint="facabookMessengerUrl">
        <svg-facebook-messenger-icon class="icon--facebook-messenger"></svg-facebook-messenger-icon>
    </amp-social-share>

    <amp-social-share type="email" data-param-url="emailUrl" class="email">
      <svg-email-icon class="icon--email"></svg-email-icon>
    </amp-social-share>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import get from 'lodash/get'
  import isEmpty from 'lodash/isEmpty'
  import { updateTitleByNodeType } from 'mixins/utilities'

  import SvgFacebookIcon from 'static/svg/icon_facebook.svg'
  import SvgFacebookMessengerIcon from 'static/svg/icon_messenger.svg'
  import SvgTwitterIcon from 'static/svg/icon_twitter.svg'
  import SvgWhatsappIcon from 'static/svg/icon_whatsapp.svg'
  import SvgEmailIcon from 'static/svg/icon_email.svg'
  import SvgShareIcon from 'static/svg/icon_share.svg'
  import SvgPinterestIcon from 'static/svg/icon_pinterest.svg'

  export default {
    name: 'amp-share-pane',
    props: {
      node: {
        type: Object,
        default: {},
      },
      mode: {
        type: String,
        default: '',
      },
      quote: {
        type: String,
        default: '',
      },
    },
    methods: {
      ...mapGetters(['requestDomain']),
    },
    computed: {
      enableLinks() {
        return get(this.$store.state, 'settings.share', false)
      },
      title() {
        return updateTitleByNodeType({type: get(this, 'node.type', ''), originalTitle: get(this.node, 'title', '')})
      },
      shareTitle() {
        if (this.quote) return this.quote
        return this.title
      },
      twitterUrl() {
        return `${this.shareUrl}&related=&via=AbacusNews`
      },
      facabookMessengerUrl() {
        return `fb-messenger://share/?link=${this.shareUrl}&app_id=${this.facebookAppID}`
      },
      emailUrl() {
        return `mailto:?subject=Abacus: ${this.shareTitle}&body=${this.subheading || this.shareTitle}%0D%0A${this.shareUrl}`
      },
      facebookUrl() {
        if (this.mode === 'blockquote') {
          const quote = !isEmpty(this.shareTitle) ? `&quote=${this.shareTitle}` : ''
          return `${this.shareUrl}&src=sdkpreparse${quote}`
        }
        return `${this.shareUrl}&src=sdkpreparse`
      },
      facebookAppID() {
        return get(this.$store.state, 'settings.FB_APP_ID', '')
      },
      nodeUrl() {
        return get(this.node, 'relative_url', '')
      },
      shareUrl() {
        return `${this.requestDomain()}${this.nodeUrl}`
      },
    },
    components: {
      SvgFacebookIcon,
      SvgFacebookMessengerIcon,
      SvgWhatsappIcon,
      SvgTwitterIcon,
      SvgEmailIcon,
      SvgShareIcon,
      SvgPinterestIcon,
    },
  }
</script>

<style lang="scss" scoped>
  .sharePane{
    display: flex;
    justify-content: space-between;
    max-width: rem-calc(320);
    margin-top: rem-calc(28);
    margin-left: rem-calc(5);
    cursor: not-allowed;
    
    &.enable {
      cursor: pointer;
    }

    &.blockquote {
      margin-top: 0;
      margin-left: rem-calc(15);
      max-width: rem-calc(75);
      justify-content: flex-start;
      amp-social-share {
        width: rem-calc(10);
        
        &[type="whatsapp"],
        &[type="facebookmessenger"],
        &[type="email"] {
          display: none;
        }
      }
    }

    amp-social-share {
      background-image: none;
      background-color: transparent;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      width: rem-calc(43);
      outline: none;
    }

    a {
      width: rem-calc(60);
      height: rem-calc(44);
      display: flex;
      align-items: center;
      justify-content: center;
      outline: none;
    }
    
    .icon {
      &--facebook {
        width: rem-calc(11);
        height: rem-calc(23);
      }
      &--twitter {
        margin-top: rem-calc(2);
        width: rem-calc(22);
        height: rem-calc(18);
      }
      &--whatsapp {
        width: rem-calc(21);
        height: rem-calc(21);
      }
      &--facebook-messenger {
        width: rem-calc(20);
        height: rem-calc(20);
      }
      &--email{
        width: rem-calc(20);
        height: rem-calc(15);
      }
    }

    svg {
      fill: $rose
    }
  }
</style>



// WEBPACK FOOTER //
// AmpSharePane.vue?5abe66df